import { FieldParams } from "@/components/package-components/constants";
import styles from "./opening-hours-variant-01.module.scss";

export const DaySchedule = ({
  value,
  id,
}: {
  value: FieldParams;
  id: string;
}) => (
  <li className={`${styles.list__item} list__item-${id}`}>
    <span className={`${styles.list__item__label} list__item__label-${id}`}>
      {value.label}
    </span>
    <span className={`${styles.list__item__value} list__item__value-${id}`}>
      {value.value}
    </span>
  </li>
);
